// @flow
import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { withHelmet } from 'infrastructure/seo/Helmet';
import { STATUS_LOADING, STATUS_FAILURE } from 'constants/statusConstants';
import type { Status } from 'types/Status';
import type { CentenaireDocumentType } from 'types/Centenaire';
import Loading from 'components/fragments/Loading';
import CentenaireDownloadContainer from 'containers/centenaire/CentenaireDownloadContainer';
import CentenaireAssociesContainer from 'containers/centenaire/CentenaireAssociesContainer';
import { Player } from 'video-react';
import { getTimeDifference, getDateFromString } from 'utils/dateUtils';
import "../../../node_modules/video-react/dist/video-react.css";
import 'components/centenaire/CentenaireVideo.css';

export type StateProps = {
  title: string,
  featured_media: {
    src: string,
    legend: string
  },
  document: CentenaireDocumentType,
  status: Status,
  statusDocument: Status
};

type HistoryProps = {
  history: any
};

type OwnProps = {
  match: {
    params: {
      document: string,
      slug: string,
    }
  },
  location: {
    state: {
      queryCentenaire: string,
      mode: string,
    }
  }
};

type State = {
  shareOpen: boolean
};

export type DispatchProps = {
  fetchPageList: (slug: string) => void,
  fetchCentenaireDocument: (document: string) => void,
};

type Props = StateProps & OwnProps & DispatchProps & HistoryProps;

class CentenairePage extends PureComponent<Props, State> {
  props: Props;
  state = {
    shareOpen: false
  };

  componentDidMount() {
    this.props.fetchCentenaireDocument(this.props.match.params.document);
    this.props.fetchPageList('centenaire');
    const { statusDocument } = this.props;
    if (statusDocument === STATUS_FAILURE) {
      this.props.history.push('/404');
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { document, slug } = this.props.match.params;
    const { statusDocument } = this.props;
    if (prevProps.match.params.document !== document || prevProps.match.params.slug !== slug) {
      this.props.fetchCentenaireDocument(document);
      this.props.fetchPageList('centenaire');
    }
    if (statusDocument === STATUS_FAILURE) {
      this.props.history.push('/404');
    }
  }

  render() {
    const { featured_media, statusDocument } = this.props;

    if (statusDocument === STATUS_LOADING) {
      return <Loading isBlue backgroundColor={'#013974'} />;
    }

    const {
      id,
      title,
      description,
      year,
      copyright,
      author,
      date,
      img,
      imgPreview,
      download,
      video,
      club,
      type
    } = this.props.document;
    const datejs = getDateFromString(date);
    let linkReturn = '/histoires-de-rugby';
    let textReturn = 'Retour à l\'accueil';
    let queryCentenaire = '';
    if (this.props.location.state && (this.props.location.state.queryCentenaire || this.props.location.state.mode)) {
      textReturn = 'Retour aux résultats de recherche';
      linkReturn = '/histoires-de-rugby/resultats-de-recherche';
      if (this.props.location.state.mode === 'map') {
        linkReturn = '/histoires-de-rugby/carte';
      }
      queryCentenaire = this.props.location.state.queryCentenaire;
    }
    return (
      <React.Fragment>
        <div className="centenaire-search">
          <div
            className="centenaire-search__background"
            style={{ backgroundImage: `url(${featured_media.src})` }}>
          </div>
          <div className="container" style={{zIndex:3, position: 'relative'}}>
            <Link
              to={{
                pathname: linkReturn,
                state: {
                  queryCentenaire: queryCentenaire
                }
              }}
              className="link-chevron link-chevron--left mb-3">
              <i className="icon icon-chevron-left"></i>
              <span>
                {textReturn}
              </span>
            </Link>
            <article className="centenaire-publication">
              <div className="centenaire-publication__thumbnail">
                {(type === 'Photo' || type === 'image') &&
                <img src={imgPreview} alt={title} />}
                {(type === 'Video' || type === 'video') &&
                <Player
                  playsInline
                  poster={imgPreview}
                  src={video}
                  fluid={false}
                />}
              </div>
              <div className="centenaire-publication__body">
                <div className="centenaire-publication__info ft-h6 ft-up ft-color-tertiary mb-3 mb-lg-4">
                  {club.length > 0 && 
                  <span><i className="icon icon-jersey is-inline"></i>{club}</span>}
                  <span><i className="icon icon-calendar is-inline"></i>{year}</span>
                </div>
                <h1 className="ft-secondary mb-2">{ title }</h1>
                <p className="mb-0 mb-lg-1">{description}</p>
                <span className="ft-h6 ft-up ft-color-tertiary">
                  {copyright ? '© '+copyright.replace('©','').trim() : '' }
                </span>
                <div className="centenaire-publication__footer mt-2">
                  <div className="ft-h6 ft-up ft-color-tertiary mb-2">
                    <div className="ft-right">
                      <span>
                      </span>
                    </div>
                    <span>
                     {datejs && 
                      getTimeDifference(new Date(), datejs)} 
                     {author && 
                      <span> - Par { author }</span> }
                    </span>
                  </div>
                  <div className="centenaire-publication__action">
                    <CentenaireDownloadContainer src={download ? download : img} id={id} title={title} />
                  </div>
                </div>
              </div>
            </article>
            <CentenaireAssociesContainer queryCentenaire={queryCentenaire} actuel={id} />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withHelmet(CentenairePage)((Helmet, pageProps) => {
  const { document: { title, imgPreview, description } } = pageProps;
  const ogimage = imgPreview;
  
  return (
  <Helmet>
    <title>{pageProps.title+ ' - '+ title}</title>
    <link rel={'canonical'} href={window.location.href} />
    <meta name={'description'} content={description} />
    <meta property={'og:url'} content={window.location.href} />
    <meta property={'og:title'} content={pageProps.title + ' - '+title} />
    <meta property={'og:description'} content={'#Histoiresderugby - '+description} />
    {ogimage && <meta property={'og:image'} content={ogimage} />}
    {ogimage && <meta property={'og:image:url'} content={ogimage} />}
  </Helmet>
  );
});
